export default {
  name: 'marking--exportFile',
  apiService: 'shoes',
  apiPath: '/admin/export_file',
};